/**
 * Builds the URLs of QC's own applications from the deployment environment name.
 *
 * Mirrors com.qualificationcheck.util.QCheckUrls on the Java side. The convention is
 * <application>-<environment>.<domain> (api-preprod, app-preprod). Two environments
 * predate it and are resolved explicitly: prod is <application>.<domain>, and local is
 * <application>.<local domain>, which assumes a hosts-file entry. No local port is
 * assumed -- run a service on a plain port and set the matching VUE_APP_QC_URL_*
 * override instead.
 *
 * Any single URL can be overridden at build time with VUE_APP_QC_URL_APP or
 * VUE_APP_QC_URL_API, and the domains with VUE_APP_QC_DOMAIN / VUE_APP_QC_LOCAL_DOMAIN.
 * These are referenced statically on purpose: Vue CLI inlines them via DefinePlugin,
 * so dynamic lookups such as process.env['VUE_APP_' + x] would not be substituted.
 */

const DOMAIN = process.env.VUE_APP_QC_DOMAIN || 'qualificationcheck.com'
const LOCAL_DOMAIN = process.env.VUE_APP_QC_LOCAL_DOMAIN || 'qualificationcheck.local'

const OVERRIDES = {
  app: process.env.VUE_APP_QC_URL_APP,
  api: process.env.VUE_APP_QC_URL_API
}

// NODE_ENV carries the build mode; map it onto the deployment environment name the
// backend services use for callback.env.
function envName() {
  switch (process.env.NODE_ENV) {
    case 'production':
      return 'prod'
    case 'preprod':
      return 'preprod'
    case 'sandbox':
      return 'sandbox'
    default:
      return 'localhost'
  }
}

function urlFor(application) {
  const override = OVERRIDES[application]
  if (override) {
    return override.replace(/\/+$/, '')
  }

  const env = envName()

  if (env === 'localhost') {
    return 'http://' + application + '.' + LOCAL_DOMAIN
  }
  if (env === 'prod') {
    return 'https://' + application + '.' + DOMAIN
  }
  return 'https://' + application + '-' + env + '.' + DOMAIN
}

export function appUrl() {
  return urlFor('app')
}

export function apiUrl() {
  return urlFor('api')
}

export default { appUrl, apiUrl }
